<div class="flex-row column align-center row-gap-20 p-24" *ngIf="!data.rewardGiven && !data.noReward">
  <img class="max-width-md-11" src="assets/new-assets/reward-logo.svg" alt="Reward">
  <p class="text-dark fs-32 fw-9 lh-32">{{data.amount | currency:'INR':'symbol'}}</p>
  <h3 class="text-center fw-8 fs-24">{{data.tittle}}</h3>
  <p class="text-center max-width-23 fw-6 lh-24">{{data.desc}}</p>
  <button type="button" class="btn btn-primary width-32 full-md" (click)="closeDialog()">Okay, got it!</button>
</div>

<div class="flex-row column align-center row-gap-20 p-24 full" *ngIf="data.rewardGiven && !data.noReward">
  <img class="max-width-md-11" src="assets/new-assets/reward-logo.svg" alt="Reward">
  <p class="text-center max-width-23 fs-18 fs-md-16 fw-8">You have unlocked a coupon reward of {{data.amount |
    currency:'INR':'symbol'}}</p>
  <p class="fw-5 text-secondary">You will get the cashback in your UPI id</p>
  <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md" specialChar
    [formControl]="name" placeholder="Enter your name" *ngIf="!currentUser.name && !currentUser.isEditVpa"
    aria-label="Enter your name">
  <input class="bg-white border-radius-8 pt-10 pb-10 pl-15 border-color-8ABECB width-32 full-md" [formControl]="vpa"
    placeholder="Enter your UPI id" aria-label="Enter your UPI id">
  <button type="button" class="btn btn-primary width-32 full-md" [disabled]="name.invalid || vpa.invalid || disableBtn"
    (click)="claimReward(data?._id)">Claim Reward</button>
  <button type="button" class="btn btn-outline border-none p-0" (click)="closeDialog()">Maybe Later</button>
</div>

<ng-container *ngIf="data.noReward">
  <div class="flex-row column align-center row-gap-20 p-24">
    <p class="fw-7 text-dark lh-24 text-center">Sadly, the coupon code you have used is valid only for new signups</p>
    <button type="button" class="btn btn-primary width-32 full-md" (click)="closeDialog()">Okay, got it!</button>
  </div>
</ng-container>